import React, { useState, useRef } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
const HERO_VIDEO = 'https://localcloud.ewubd.edu/backend/uploads/slider/files/1765683712415_WhatsApp%20Video%202025-12-08%20at%203.10.56%20PM.mp4';
function RankBadge({
  top,
  label,
  rank,
  color
}: {
  top: string;
  label: string;
  rank: string;
  color: string;
}) {
  return <div className="flex w-16 flex-col items-center rounded-md bg-white/95 p-1.5 shadow-md ring-1 ring-black/5" data-id="element-156">
      <div className="flex h-11 w-11 flex-col items-center justify-center rounded-md text-center text-white" style={{
      backgroundColor: color
    }} data-id="element-157">
        <span className="text-[6px] font-semibold uppercase leading-none" data-id="element-158">
          {top}
        </span>
        <span className="mt-0.5 text-[7px] font-bold uppercase leading-tight" data-id="element-159">
          {label}
        </span>
      </div>
      <span className="mt-1 text-sm font-bold text-slate-800" data-id="element-160">{rank}</span>
    </div>;
}
export function Hero() {
  const [muted, setMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const toggleMute = () => {
    setMuted(m => {
      const next = !m;
      if (videoRef.current) videoRef.current.muted = next;
      return next;
    });
  };
  return <section className="relative h-[78vh] min-h-[560px] w-full overflow-hidden bg-[#0f2d5c]" data-id="element-161">
      <video ref={videoRef} src={HERO_VIDEO} autoPlay loop muted playsInline aria-label="East West University campus video" className="absolute inset-0 h-full w-full object-cover" data-id="element-162" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/30" data-id="element-163" />

      {/* Ranking badges */}
      <div className="absolute left-4 top-40 z-10 flex flex-col gap-4 sm:left-8" data-id="element-164">
        <RankBadge top="Ranked" label="2026" rank="3rd" color="#b58a24" data-id="element-165" />
        <RankBadge top="QS World" label="Rankings" rank="4th" color="#e6a817" data-id="element-166" />
      </div>

      {/* Mute button */}
      <button onClick={toggleMute} aria-label={muted ? 'Unmute' : 'Mute'} className="absolute bottom-6 left-4 z-10 flex h-11 w-11 items-center justify-center rounded-full bg-[#0f2d5c]/85 text-white shadow-lg transition-colors hover:bg-[#0f2d5c] sm:left-8" data-id="element-167">
        {muted ? <VolumeX className="h-5 w-5" data-id="element-168" /> : <Volume2 className="h-5 w-5" data-id="element-169" />}
      </button>
    </section>;
}